/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useState, useEffect, useRef } from 'react';
import translate from 'services/i18n/translate';
import { useParams, useHistory } from 'react-router-dom';
import { useResizeObserver } from 'hooks/useResizeObserver';
import { PublicRoutePath } from 'routes/paths';
import RouterUtils from 'services/utils/RouterUtils';
import MainSection from 'types/MainSection';
import AppConfig from 'services/AppConfig';

interface Params {
  section: MainSection;
  id?: string;
}

export default function About(): JSX.Element {
  const { id, section } = useParams<Params>();
  const { push, location } = useHistory();
  const navBarRef = useRef<HTMLDivElement>(null);
  const mainDivRef = useRef<HTMLDivElement>(null);
  const navBarDimensions = useResizeObserver(navBarRef);
  const divDimensions = useResizeObserver(mainDivRef);

  const [iframeUrl, setIframeUrl] = useState('');
  const [offSetMultiple, setOffSetMultiple] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    AppConfig.env.ABOUT_LINKS.forEach((e) => {
      if (e.id === id) {
        setIframeUrl(e.url);
      }
    });
  }, [location.pathname, id]);

  useEffect(() => {
    AppConfig.env.ABOUT_LINKS.forEach((e, index) => {
      if (id === e.id) {
        setOffSetMultiple(AppConfig.env.ABOUT_LINKS.length * index);
      }
    });
  }, [navBarDimensions, offSetMultiple, id]);

  const handleSelection = (selectedRoute: string) => {
    push(RouterUtils.getRouteWithDynamicValues(PublicRoutePath.ABOUT_ELEMENT, [section, selectedRoute]));
  };

  const handleMobileMenu = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <>
      <div className="component about-links-wrapper" ref={mainDivRef} id="AboutPage">
        <div
          className={`component-inner background-white ${isOpen ? 'expanded' : ''} `}
          onClick={handleMobileMenu}
          id="AboutPage_button___mobileMenu"
        >
          <div className="link-navigation">
            {AppConfig.env.ABOUT_LINKS.map((link) => {
              const title = link.translationKey as keyof typeof translate;
              return (
                <a
                  key={link.id}
                  onClick={() => handleSelection(link.id)}
                  className={id === link.id ? 'link-active' : ''}
                  id={`AboutPage_button___${link.id}`}
                >
                  <h4>{translate[title]}</h4>
                </a>
              );
            })}
            <div
              className="link-navigation-bar link-active"
              ref={navBarRef}
              style={{
                transform: `translateX(${
                  (navBarDimensions.width / AppConfig.env.ABOUT_LINKS.length) * offSetMultiple
                }px)`,
                width: `calc(60%/${AppConfig.env.ABOUT_LINKS.length})`,
              }}
            />
            <span className="link-navigation-chevron" />
          </div>
        </div>
      </div>
      <div className="component about-container-wrapper">
        <div className="component-inner no-background">
          <iframe id="AboutPage_iframe" title="vodafone" src={iframeUrl} style={{ maxWidth: divDimensions.width }} />
        </div>
      </div>
    </>
  );
}
